/* eslint-disable */
import React, { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import {
  ConversationProvider,
  createSocketIoAdapter,
  createChatClient,
} from "@lobees/chat-core";

import { getData, postData, putData, deleteData, uploadMultipleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import ConversationLeftPanel from "../ConversationLeftPanel/ConversationLeftPanel";
import ConversationRightPanel from "../ConversationRightPanel/ConversationRightPanel";

import { assetImages } from "constants";
import ShowImageModal from "components/common/Modals/ShowImageModal";
import ConversationHistoryModal from "../Modals/ConversationHistoryModal";
import AddToGroupModal from "../Modals/AddToGroupModal";
import AskPayment from "components/common/Modals/AskPayment";

// The chat adapter/client only need to be constructed ONCE for the lifetime
// of this component tree. Building them inline in the component body (as the
// old `const socket = io(url.SERVER_URL)` did) reconnected the socket on
// every re-render; module-scope construction plus ConversationProvider's own
// mount-only connect() effect fixes that.
const chatAdapter = createSocketIoAdapter({ url: url.SERVER_URL });

const chatClient = createChatClient({
  request: {
    get: getData,
    post: postData,
    put: putData,
    del: deleteData,
    uploadFiles: uploadMultipleFile,
  },
  endpoints: {
    sendChat: url.API_BASE_URL + url.API_SEND_CHAT,
    chatList: url.API_BASE_URL + url.API_GET_ALL_CHAT_LIST,
    chatMessages: url.API_BASE_URL + url.API_GET_ALL_CHAT_MESSAGES,
    updateChat: url.API_BASE_URL + url.API_UPDATE_CHAT,
    deleteChat: url.API_BASE_URL + url.API_DELETE_CHAT,
    removeRequireResponse: url.API_BASE_URL + url.API_REMOVE_REQUIRE_RESPONSE,
    updateTrackers: url.API_BASE_URL + url.API_UPDATE_TRACKERS,
    translateChat: url.API_BASE_URL + url.API_TRANSLATED_CHAT,
    groupListForChat: url.API_BASE_URL + url.API_GET_GROUP_LIST_FOR_CHAT,
    taskListForChat: url.API_BASE_URL + url.API_GET_TASK_LIST_FOR_CHAT,
    fileUpload: url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD,
  },
  socketUrl: url.SERVER_URL,
  // web's Gateway.js returns a bare string on failure (error.message);
  // admin's returns an error payload object — this is the one seam that
  // differs per app.
  normalizeError: (raw) => (typeof raw === "string" ? raw : raw?.message || "Request failed"),
});

const ConversationBody = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const params = useParams();

  const [allContacts, setAllContacts] = useState([]);

  //chat history modal states
  const [showHistory, setShowHistory] = useState(false);
  const [chatSearchMessage, setChatSearchMessage] = useState("");

  //reload group details after adding member states
  const [reloadGroupDetails, setReloadGroupDetails] = useState(false);

  //reload chat after ask payment close states
  const [reloadChatAfterPayment, setReloadChatAfterPayment] = useState(false);

  const currentUser = useMemo(
    () => ({
      id: userInfo?._id,
      email: userInfo?.email,
      name: userInfo?.name,
      surname: userInfo?.surname,
      photoPath: userInfo?.photoimage?.path ?? "",
    }),
    [userInfo?._id]
  );

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CHAT")
  ) {
    return (
      <ConversationProvider adapter={chatAdapter} chatClient={chatClient} currentUser={currentUser}>
        <section className="chat_conversations">
          <div className="chat_pnlOuter">
            {/* ---  left panel ---- */}
            <ConversationLeftPanel
              setAllContacts={setAllContacts}
              allContacts={allContacts}
              params={params}
            />

            {/* --- right panel -------- */}
            <ConversationRightPanel
              allContacts={allContacts}
              //history modal states
              setShowHistory={setShowHistory}
              chatSearchMessage={chatSearchMessage}
              setChatSearchMessage={setChatSearchMessage}
              //reload group details after adding member
              reloadGroupDetails={reloadGroupDetails}
              setReloadGroupDetails={setReloadGroupDetails}
              //reload chat after ask payment close
              reloadChatAfterPayment={reloadChatAfterPayment}
              setReloadChatAfterPayment={setReloadChatAfterPayment}
            />
          </div>

          {/* show image modal */}
          <ShowImageModal />

          <ConversationHistoryModal
            showHistory={showHistory}
            setShowHistory={setShowHistory}
            searchMessage={chatSearchMessage}
          />

          <AddToGroupModal
            myContacts={allContacts}
            afterModalClose={() => {
              setReloadGroupDetails(true);
            }}
          />

          <AskPayment onClose={() => setReloadChatAfterPayment(true)} />
        </section>
      </ConversationProvider>
    );
  } else {
    return (
      <section className="chat_conversations">
        <div className="empty_access text-center">
          <div className="empty_pic mb-4">
            {" "}
            <img src={assetImages.emptyVector} alt="" />
          </div>
          <div className="empty_text">
            <p className="fs-lg text-gray fw-semibold mb-4">
              Sorry....! You don't have privilege to see this content
            </p>
          </div>
        </div>
      </section>
    );
  }
};

export default ConversationBody;
